import { useGenerationStatus } from '@hooks/apiHooks/generationsHooks';
//import { usePersonaBySlug } from '@hooks/apiHooks/personasHooks';
import { useGenerationState } from '@hooks/storeHooks/useGenerationState';
import { useEffect } from 'react';
import { /*Link,*/ useParams, useSearchParams } from 'react-router-dom';
//import SessionBackground from './Background/Background';
import { Generation } from './Generation';

const StationGenerationPage: React.FC = () => {
  const { slug, taskId } = useParams<{ slug: string; taskId?: string }>();
  const [searchParams] = useSearchParams();
  const { isRegeneratingMusic, isRegeneratingLyrics } = useGenerationState();

  // Fetch companion data directly without triggering avatar session
  //const { data: companion } = usePersonaBySlug(slug || '');

  const isDesignerSession = searchParams.get('designSession') === 'true';
  const isPresentationSession =
    searchParams.get('presentationSession') === 'true';
  const isBusinessPlanSession =
    searchParams.get('businessPlanSession') === 'true';
  const isWebpageSession = searchParams.get('webpageSession') === 'true';
  const userInput = searchParams.get('userInput');

  const { data: musicGeneration } = useGenerationStatus(
    !isDesignerSession &&
      !isPresentationSession &&
      !isBusinessPlanSession &&
      !isWebpageSession &&
      taskId
      ? taskId
      : null,
    !isDesignerSession &&
      !isPresentationSession &&
      !isBusinessPlanSession &&
      !isWebpageSession &&
      !!taskId,
    isRegeneratingMusic,
    isRegeneratingLyrics,
  );

  useEffect(() => {
    document.body.classList.add('session-page');

    return () => {
      document.body.classList.remove('session-page');
    };
  }, []);

  if (!slug || !taskId) {
    return null;
  }

  return (
    <>
      {/*<Link
        to="/"
        className="fixed top-[17px] md:top-[28px] left-4 md:left-6 h-8 w-auto opacity-100 z-[99999]">
        <img
          src="/assets/images/logo_napster_white.svg"
          alt="Napster"
          className="h-8"
        />
      </Link>*/}
      {/*<SessionBackground
        src={companion?.data?.avatar?.backgroundImageUrl || ''}
      />*/}
      <Generation
        musicGeneration={
          isDesignerSession ||
          isPresentationSession ||
          isBusinessPlanSession ||
          isWebpageSession
            ? undefined
            : musicGeneration
        }
        userInput={
          isDesignerSession ||
          isPresentationSession ||
          isBusinessPlanSession ||
          isWebpageSession
            ? userInput || undefined
            : undefined
        }
        fanSlug={slug}
        isPresentationSession={isPresentationSession}
        isBusinessPlanSession={isBusinessPlanSession}
        isWebpageSession={isWebpageSession}
        taskId={taskId}
      />
    </>
  );
};

export default StationGenerationPage;
